import { graphql, useStaticQuery } from 'gatsby';
import { Menu, X } from 'lucide-react';
import React, { FC, PropsWithChildren, useState } from 'react';
import * as style from './index.module.scss';
import { toTree } from '../../tools/Tree';
import Collapsible from '../Collapsible';
import Header from '../Header';

const Layout: FC<PropsWithChildren<{ location: Location }>> = ({ children, location }) => {
    const { allMdx }: Queries.NoteLayoutQuery = useStaticQuery(graphql`
        query NoteLayout {
            allMdx(
                filter: { fields: { type: { eq: "note" }, isPublished: { eq: true } } }
                sort: { fields: { sortKey: ASC } }
            ) {
                nodes {
                    fields {
                        depth
                        path
                    }
                    frontmatter {
                        title
                    }
                }
            }
        }
    `);
    const menu = toTree(
        allMdx.nodes.map((node) => ({
            depth: node.fields.depth,
            path: node.fields.path,
            title: node.frontmatter.title,
            isOpen: location.pathname.includes(node.fields.path),
        })),
    );

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={style.div}>
            <button className={style.menuButton} onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? <X /> : <Menu />}
            </button>
            <aside className={isOpen ? style.open : ''}>
                <Header />
                <nav>
                    {menu.items.map((item) => (
                        <Collapsible
                            key={item.path}
                            pathname={location.pathname}
                            node={item}
                            onClick={() => setIsOpen(false)}
                        />
                    ))}
                </nav>
            </aside>
            <main>{children}</main>
        </div>
    );
};
export default Layout;
